import {Fragment, useContext, useRef} from 'react'
import {Dialog, Transition} from '@headlessui/react'
import {EntityContext} from "../../context/EntityContext";
import {APIDeletePlan} from "../../api/plans/Plans";
import {APIDeleteMap} from "../../api/maps/Maps";
import { APIDeleteOrder } from '../../api/orders/Orders';
import { S3DeleteAllFilesInDirectory } from '../../helper/s3ClientHandler';
import { UserContext } from '../../context/UserContext';
import { ListContext } from '../../context/ListContext';
import {TfiClose} from "react-icons/tfi";



export default function DeletePlans() {
    const {user} = useContext(UserContext);
    const cancelButtonRef = useRef(null)
    const {openDeleteModal,currentEntity,currentSetting, setOpenDeleteModal} = useContext(EntityContext);
    const { fetchListData } = useContext(ListContext);
    const handelDeletePlan = () => {

        if(currentSetting?.type === "myPlans") {
            APIDeletePlan(currentEntity?.id, user?.companyId).then(function(result) {
                const path = `${user.companyId}/plans/${currentEntity?.id}`;
                S3DeleteAllFilesInDirectory(path);
                setOpenDeleteModal(false);
                fetchListData();
            });
        } else if ( currentSetting?.type === "myMaps") {
            APIDeleteMap(currentEntity?.id, user?.companyId).then(function(result) {
                setOpenDeleteModal(false);
                fetchListData();
            });
        } else if ( currentSetting?.type === "myOrder") {
            if(currentEntity?.stage !== "draft") return;
            APIDeleteOrder({id: currentEntity?.id, companyId: user.companyId}).then(function(result) {
                const path = `${user.companyId}/orders/${currentEntity?.id.replaceAll('-','/')}/documents`;
                S3DeleteAllFilesInDirectory(path);
                setOpenDeleteModal(false);
                fetchListData();
            });
        }
    }


    return (
        <Transition.Root show={openDeleteModal} as={Fragment}>
            <Dialog className="relative z-10" initialFocus={cancelButtonRef} onClose={setOpenDeleteModal}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >

                            <Dialog.Panel className='flex max-w-2xl flex-col max-h-full sm:max-h-max h-full md:h-auto rounded-lg bg-white text-left shadow-xl transition-all w-full relative'>
                                <button
                                    type='button'
                                    className='absolute z-40 lg: lg:-top-6 lg:-right-6 top-2 right-2'
                                    onClick={() => setOpenDeleteModal(false)}
                                    ref={cancelButtonRef}
                                >
                                    <TfiClose className={"lg:size-16 border-gray-500/80 border-2 bg-white hover:bg-gray-300 lg:p-4 size-12 p-2 lg:rounded-full rounded-md"}/>
                                </button>


                                <div className='flex w-full h-full'>
                                    <div className={' flex flex-col w-full'}>
                                        <Dialog.Title
                                            as='h3'
                                            className='pt-8 px-8  font-bold text-2xl leading-6 text-gray-900-'>
                                            {currentSetting?.deleteDialog?.headline}
                                        </Dialog.Title>
                                        <div className='p-8 flex flex-col flex-1  overflow-y-auto'>
                                            <p className="text-sm text-gray-600">
                                                {currentSetting?.deleteDialog?.text}
                                            </p>
                                        </div>
                                        <div className="p-8 sm:flex-row-reverse flex w-full flex-col-reverse gap-4">
                                            <button
                                                type="button"
                                                className={"text-center truncate items-center rounded-md bg-white text-red  border-red border-2 disabled:text-gray-600/40 disabled:border-gray-500 px-4 py-3 text-sm font-semibold"}
                                                onClick={handelDeletePlan}
                                            >
                                                {currentSetting?.deleteDialog?.button}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </Dialog.Panel>

                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    )
}
